var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticStyle:{"background-color":"#ffffff"},attrs:{"app":"","inset":""}},[_c('v-col',{staticClass:"text-left"},[_vm._v(" USUÁRIO - "+_vm._s(this.nomeUsuario())+" ")]),_c('v-col',{staticClass:"text-right"},[_vm._v(" Versão do Sistema - 2.0")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }